import request from "@/utils/request";

export function getList(data) {
  return request({ url: "/poster/list", method: "post", data: data });
}

export function getHomeList() {
  return request({ url: "/poster/homeList", method: "post" });
}

export function getDetail(id) {
  return request({ url: `/poster/${id}/info`, method: "post" });
}

export function getOneByTitle(title) {
  return request({ url: `/poster/getOneByTitle/${title}`, method: "get" });
}

export function getSysNotice() {
  return request({ url: `/poster/notice`, method: "get" });
}
